<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">{{ $t("t_manager_user_role_dynamic") }}</h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormTimKiem()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="fn_handle('create', null)"
              v-if="profile_user.roles === 'Admin'"
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="left"
                  ref="ruleFormRef"
                  @submit.prevent
                  :model="tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="6">
                      <el-form-item :label="$t('t_user_role_dynamic_name')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['name']"
                          :placeholder="$t('t_user_role_dynamic_name')"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <a
                        class="btn btn-soft-secondary btn-border waves-effect waves-light mx-3"
                        style="width: 80px"
                        @click="fn_showFormTimKiem()"
                      >
                        {{ $t("t-hide") }}
                      </a>
                      <button
                        class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                        style="width: 100px"
                        native-type="submit"
                        @click="fn_TimKiem()"
                      >
                        {{ $t("t-search") }}
                      </button>
                    </b-col>
                  </b-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            max-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="70"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('t_user_role_dynamic_name')"
              min-width="150"
              header-align="center"
              align="left"
              :sortable="true"
            >
              <template #default="scope">
                {{ formatRoleName(scope.row.name) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="description"
              :label="$t('t_user_role_dynamic_description')"
              min-width="300"
              header-align="center"
              align="left"
            >
              <template #default="scope">
                <el-tooltip
                  :content="scope.row.description"
                  placement="top"
                  :disabled="!scope.row.description"
                >
                  <span class="description-cell">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="150px"
              v-if="profile_user.roles === 'Admin'"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.row)"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.row)"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
        </div>
      </div>

      <!-- Dialog thêm mới / cập nhật -->
      <el-dialog
        v-model="showDialog"
        :title="dialogTitle"
        width="500"
        align-center
        :close-on-click-modal="false"
        :before-close="closeDialog"
      >
        <div class="dialog-form">
          <template v-if="typeForm === 'createForm'">
            <p>{{ $t("t_user_role_dynamic_name") }} <span class="text-danger">*</span></p>
            <el-input
              type="text"
              v-model="nameSuffix"
              clearable
              :placeholder="$t('t_place_user_role_dynamic_name')"
              maxlength="50"
              @input="onNameInput"
            ></el-input>
            <p class="dialog-form__error" v-show="errorMessage">
              {{ errorMessage }}
            </p>
          </template>
          <p :style="typeForm === 'createForm' ? 'margin-top: 16px' : ''">{{ $t("t_user_role_dynamic_description") }}</p>
          <el-input
            type="textarea"
            v-model="description"
            clearable
            :placeholder="$t('t_place_user_role_dynamic_description')"
            :rows="3"
          ></el-input>
          <div class="dialog-form__btns">
            <el-button type="primary" @click="actionUserRoleDynamic(typeForm)">
              {{ typeForm === "createForm" ? $t("t-add") : $t("t-update") }}
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </Layout>
</template>

<script setup>
import Layout from "../../layouts/main.vue";
import { onMounted, reactive, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import MethodService from "../../service/MethodService";
import Swal from "sweetalert2";
import toastr from "toastr";
import DataForm from "./dataUserRoleDynamic";
import mushroom from "cem-primary-api";
import { profileUserStore } from "../../stores/profileUser";
const profile_user = profileUserStore();
import { useI18n } from "vue-i18n";
const { t } = useI18n();

let loading = ref(true);
const router = useRouter();
const route = useRoute();
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const dataTables = reactive({ value: [] });
const pageSizeDefault = ref(20);
const showDialog = ref(false);
const errorMessage = ref("");
const nameSuffix = ref("");
const description = ref("");
const typeForm = ref("createForm");
const idUserRoleDynamic = ref("");
const namePattern = /^[a-zA-Z0-9]+$/;

const formatRoleName = (name) => {
  if (!name) return "";
  return name.startsWith("DYN_") ? name.substring(4) : name;
};

const dialogTitle = computed(() => {
  if (typeForm.value === "createForm") {
    return t("t_add_user_role_dynamic");
  }
  return `${t("t_update_user_role_dynamic")} ${formatRoleName(currentRowName.value)}`;
});

const currentRowName = ref("");

const fullName = computed(() => {
  return "DYN_" + (nameSuffix.value ? nameSuffix.value.trim() : "");
});

const closeDialog = () => {
  errorMessage.value = "";
  nameSuffix.value = "";
  description.value = "";
  showDialog.value = false;
};

const onNameInput = () => {
  if (nameSuffix.value) {
    nameSuffix.value = nameSuffix.value.replace(/\s/g, "");
  }
  if (errorMessage.value) {
    errorMessage.value = "";
  }
};

const validateName = () => {
  const suffix = nameSuffix.value ? nameSuffix.value.trim() : "";
  if (!suffix) {
    errorMessage.value = t("t_user_role_dynamic_validate_required");
    return false;
  }
  if (!namePattern.test(suffix)) {
    errorMessage.value = t("t_user_role_dynamic_validate_pattern");
    return false;
  }
  errorMessage.value = "";
  return true;
};

const fn_handle = (type, row) => {
  nameSuffix.value = "";
  description.value = "";
  errorMessage.value = "";
  if (type === "create") {
    typeForm.value = "createForm";
    showDialog.value = true;
  }
  if (type === "update") {
    typeForm.value = "updateForm";
    idUserRoleDynamic.value = row.id;
    currentRowName.value = row.name;
    description.value = row.description || null;
    showDialog.value = true;
  }
  if (type === "delete") {
    Swal.fire({
      title: t("swal_noti"),
      text: t("t_noti_user_role_dynamic_delete"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.user_role_dynamic.deleteAsync({
            id: row.id,
          });
          if (response.result) {
            toastr.success(t("toastr_delete_success"));
            getUserRoleDynamics();
          }
        } catch (e) {
          console.error("Có lỗi: %o", e);
          if (e.code === 2000 && e.meta && e.meta.users) {
            const users = e.meta.users;
            Swal.fire({
              title: t("t_user_role_dynamic_delete_error_title"),
              html: `<div style="text-align: left; padding: 10px;">
                       <p>${t("t_user_role_dynamic_delete_error_desc", { role: formatRoleName(row.name) })}</p>
                       <div style="max-height: 150px; overflow-y: auto; background: #f8f9fa; border: 1px solid #e9ebec; border-radius: 4px; padding: 10px; margin-top: 10px;">
                         ${users.map(u => `<div style="margin-bottom: 6px; font-weight: 600; color: #495057;">• ${u.account}</div>`).join("")}
                       </div>
                     </div>`,
              icon: "warning",
              confirmButtonColor: "#f46a6a",
              confirmButtonText: t("swal_accept"),
            });
          } else if (e.code === 2001 && e.meta && e.meta.menu) {
            const menus = e.meta.menu;
            const lang = localStorage.getItem("language") || "vi";
            const menuNames = menus.map((m) => {
              const langName = m.label_lang?.[lang];
              return langName || m.label || "";
            });
            Swal.fire({
              title: t("t_user_role_dynamic_delete_menu_error_title"),
              html: `<div style="text-align: left; padding: 10px;">
                       <p>${t("t_user_role_dynamic_delete_menu_error_desc", { role: formatRoleName(row.name) })}</p>
                       ${menuNames.map(name => `<div style="margin-bottom: 4px;">• ${name}</div>`).join("")}
                     </div>`,
              icon: "warning",
              confirmButtonColor: "#f46a6a",
              confirmButtonText: t("swal_accept"),
            });
          } else {
            MethodService.showError(e.code);
          }
        }
      }
    });
  }
};

const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
  router
    .replace(
      MethodService.routerReplace("DanhSachUserRoleDynamic", tableRules)
    )
    .catch(() => {});
};

const fn_TimKiem = () => {
  if (tableRules.dataSearch.value["name"]) {
    tableRules.dataSearch.value["name"] =
      tableRules.dataSearch.value["name"].trim();
  }
  tableRules.filters = MethodService.filterTable(
    JSON.stringify(tableRules.dataSearch)
  );
  tableRules.offset = 0;
  tableRules.sort = "";
  getUserRoleDynamics();
};

const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};
const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};
const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};
const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};
const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  getUserRoleDynamics();
};
const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  getUserRoleDynamics();
};
const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

const actionUserRoleDynamic = async (type) => {
  if (type === "createForm" && !validateName()) {
    return;
  }

  type === "createForm"
    ? await createUserRoleDynamicAsync()
    : await updateUserRoleDynamicAsync();

  showDialog.value = false;
};

const createUserRoleDynamicAsync = async () => {
  try {
    const response = await mushroom.user_role_dynamic.createAsync({
      name: fullName.value,
      description: description.value || null,
    });
    if (response.result) {
      toastr.success(t("toastr_add_success"));
      await getUserRoleDynamics();
      return true;
    }
    return false;
  } catch (e) {
    console.error("Có lỗi: %o", e);
    if (e.code === 401 && e.meta && e.meta.field === "$unique_key") {
      Swal.fire({
        title: t("t_user_role_dynamic_duplicate_error_title"),
        text: t("t_user_role_dynamic_duplicate_error_desc", { role: nameSuffix.value.trim() }),
        icon: "warning",
        confirmButtonColor: "#f46a6a",
        confirmButtonText: t("swal_accept"),
      });
    } else {
      MethodService.showError(e.code);
    }
    return false;
  }
};

const updateUserRoleDynamicAsync = async () => {
  try {
    const response = await mushroom.user_role_dynamic.partialUpdateAsync({
      id: idUserRoleDynamic.value,
      description: description.value || null,
    });
    if (response.result) {
      toastr.success(t("toastr_update_success"));
      await getUserRoleDynamics();
      return true;
    }
    return false;
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
    return false;
  }
};

const getUserRoleDynamics = async () => {
  mushroom.user_role_dynamic.invalidCache();
  let dataFilter = {
    filters: tableRules.filters,
    fields: tableRules.fields,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
  };
  router
    .replace(
      MethodService.routerReplace("DanhSachUserRoleDynamic", tableRules)
    )
    .catch(() => {});
  try {
    const response = await mushroom.user_role_dynamic.listAsync(dataFilter);
    if (response.result) {
      dataTables.value = response.result;
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  fn_hashUrl();
  await getUserRoleDynamics();
});
</script>

<style lang="scss" scoped>
.dialog-form {
  position: relative;

  &__error {
    color: var(--el-color-danger);
    position: absolute;
    font-size: 12px;
  }

  &__btns {
    margin-top: 25px;
    text-align: center;
  }
}

.description-cell {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
